module.exports = __webpack_public_path__ + "static/media/bannerToken.0698904a.jpg";